import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { DespesaResponseDTO, DespesaDTO, DespesaFiltrosDTO, DespesaDashboardResponseDTO, TotalMoedaDTO } from '../../models/gerenciar-contas/despesa.model';

@Injectable({
  providedIn: 'root',
})
export class DespesaService {
  constructor(private apiService: ApiService) {}

  get(url: string, data?: any): Observable<DespesaResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<DespesaResponseDTO>(path);
  }
  getById<T>(url: string): Observable<DespesaDTO> {
    return this.apiService.read<DespesaDTO>(url);
  }

  post<T>(url: string, data: DespesaDTO): Observable<DespesaDTO> {
    return this.apiService.create<DespesaDTO>(url, data);
  }

  put<T>(url: string, data: DespesaDTO): Observable<DespesaDTO> {
    return this.apiService.update<DespesaDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  searchByObservacao(observacao: string, page: number, size: number): Observable<DespesaResponseDTO> {
    return this.get('/movimento/buscar', {
      observacao,
      page,
      size,
      tipoDeTransacao: 'DESPESA'
    });
  }

  /** Listar despesas com filtros server-side */
  listarComFiltros(filtros: DespesaFiltrosDTO): Observable<DespesaDashboardResponseDTO> {
    const params: { [key: string]: string | number } = {};
    if (filtros.conta != null) params['conta'] = filtros.conta;
    if (filtros.dataInicio) params['dataInicio'] = filtros.dataInicio;
    if (filtros.dataFim) params['dataFim'] = filtros.dataFim;
    if (filtros.observacao) params['observacao'] = filtros.observacao;
    if (filtros.tipoDespesa) params['tipoDespesa'] = filtros.tipoDespesa;
    if (filtros.pessoaId != null) params['pessoaId'] = filtros.pessoaId;
    if (filtros.page != null) params['page'] = filtros.page;
    if (filtros.size != null) params['size'] = filtros.size;
    if (filtros.sort) params['sort'] = filtros.sort;

    return this.apiService.readWithParams<DespesaDashboardResponseDTO>(
      '/totaldashboard/listarDespesasPorFiltros', params
    );
  }

  /** Buscar totais por moeda */
  getTotaisPorMoeda(filtros: DespesaFiltrosDTO): Observable<TotalMoedaDTO> {
    const params: { [key: string]: string | number } = {};
    if (filtros.conta != null) params['conta'] = filtros.conta;
    if (filtros.dataInicio) params['dataInicio'] = filtros.dataInicio;
    if (filtros.dataFim) params['dataFim'] = filtros.dataFim;
    if (filtros.observacao) params['observacao'] = filtros.observacao;
    if (filtros.tipoDespesa) params['tipoDespesa'] = filtros.tipoDespesa;
    if (filtros.pessoaId != null) params['pessoaId'] = filtros.pessoaId;

    return this.apiService.readWithParams<TotalMoedaDTO>(
      '/totaldashboard/total-despesas', params
    );
  }

  /** Gerar PDF de movimento (retorna base64) */
  gerarPdfMovimento(id: number, tipoImpressao: string): Observable<string> {
    return this.apiService.postText(`/movimento/gerar-pdf-movimento/${id}/impressao/${tipoImpressao}`);
  }
}
